import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

type Props = {
  hasChanges: boolean;
  isLoading: boolean;
  isSaving: boolean;
  onClose: () => void;
  onSave: () => void;
};

const UserManagementFeatureFlagsModalFooter = ({ hasChanges, isLoading, isSaving, onClose, onSave }: Props) => (
  <Footer>
    <Button onClick={onClose} disabled={isSaving} data-test-id="user-management-feature-flags-cancel">
      Cancel
    </Button>
    <Button
      type="primary"
      onClick={onSave}
      loading={isSaving}
      disabled={isLoading || !hasChanges || isSaving}
      data-test-id="user-management-feature-flags-save"
    >
      Save
    </Button>
  </Footer>
);

export default UserManagementFeatureFlagsModalFooter;
